import portfolioImg01 from "../images/portfolio-01.JPG";
import portfolioImg02 from "../images/portfolio-02.JPG";
import portfolioImg03 from "../images/portfolio-03.JPG";
import portfolioImg04 from "../images/portfolio-04.JPG";
import portfolioImg05 from "../images/portfolio-05.JPG";
import portfolioImg06 from "../images/portfolio-06.jpg";


const portfolios = [
  {
    id: "01",
    imgUrl: portfolioImg01,
    category: "Web Design",
    title: "Problem Solving (Basic)",
    description:
      "HackerRank",
    technologies: ["HackerRank"],
    siteUrl: "#",
  },
  {
    id: "02",
    imgUrl: portfolioImg02,
    category: "Ux",   
    title: "Python",
    description:
      "HackerRank",
    technologies: ["Python"],
    siteUrl: "#",
  },
  {
    id: "03",
    imgUrl: portfolioImg03,
    category: "Ux",
    title: "SQL",
    description:
      "HackerRank",
    technologies: ["SQL"],
    siteUrl: "#",
  },
  {
    id: "04",
    imgUrl: portfolioImg04,
    category: "Web Design",
    title: "The Python Programming For Everyone Immersive Training",
    description:
      "Successfully completed the course The Python Programming For Everyone Immersive Training on 08/07/2023 as taught by SDE Arts | Octavo on Udemy",
    technologies: ["Python"],
    siteUrl: "#",
  },
  {
    id: "05",
    imgUrl: portfolioImg05,
    category: "Web Design",
    title: "Oracle SQL",
    description:
      "Successfully completed the course Oracle SQL - Step by Step SQL on 08/23/2022 as taught by Amarnath Reddy on Udemy",
    technologies: ["Oracle SQL"],
    siteUrl: "#",
  },

  {
    id: "06",
    imgUrl: portfolioImg06,
    category: "Ux",
    title: "NPTEL Online Certification",
    description:
      "Introduction to Industry 4.0 and Internet of Things",
    technologies: ["Internet of Things"],
    siteUrl: "#",
  },
 
];

export default portfolios;